/**
 配置管理--墙盒设备查询
 */
import React, { Component } from "react";
import { Modal, Button, message } from "antd";
import QRCode from "qrcode.react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import moment from "moment";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import GoodExcelIn from "./goodExcelIn";
import GoodExcelInTemp from "./goodExcelInTemp";
import {
  getModelNoList,
  getFrameWorkList,
  getUpdateTypeList,
  getStubInfoList,
  getCityList,
  prefixFile,
  stubRestart,
  unlockConnector,
  lockUnBind,
  lockSleepOrWake,
  lockOrderStatus,
} from "@/fetch/fetchApi";
import StubStruts from "@/utils/stubStruts";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import StubDetailInfo from "./stubDetailInfo";
import StubStatusUpdate from "./stubStatusUpdate";
import StubLockOrderStatus from "./stubLockOrderStatus";
import StubRestartModalS from "./stubRestartModal";
import HpcSettingModalS from "./hpcSettingModal";
import StubBindLock from "./stubBindLock";
import SeeStubTenceInfo from "./seeStubTenceInfo";

import StubParamsConfig from "./stubParamsConfig";
import FrameWorkUpdateBatch from "./frameWorkUpdateBatch";
import FrameWorkUpdate from "./frameWorkUpdate";
import DownHPCStubLog from "./downHPCStubLog";

import GetFrameWorkEdition from "./getFrameWorkEdition";
import StubStatusLog from "./stubStatusLog";
import UpdateProgress from "./updateProgress";
import DownHPCLogProgress from "./downHPCLogProgress";

import { useAuth } from "@/utils/utils";

// 国际化切换语言

/**
 * 引入设备状态列表
 */

// const TabPane = Tabs.TabPane;
const opType = {
  0: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "平台托管联营站",
      value: "0",
    },
    {
      text: "品牌联营站",
      value: "1",
    },
    {
      text: "互联互通联营站",
      value: "2",
    },
    {
      text: "专用开放站",
      value: "3",
    },
    {
      text: "专用内部站",
      value: "4",
    },
    {
      text: "品牌站",
      value: "5",
    },
    // ,
    // {
    //   text: '互联互通站',
    //   value: "7",
    // }
  ],
  1: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "自建站", // '自建站',
      value: "6",
    },
    {
      text: "共建站", // '自建站',
      value: "8",
    },
  ],
};
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class WallBoxStubList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.initCity = [];
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.operationMode = window.LayoutTab.tabParam.operationMode;
      this.powerStationType = window.LayoutTab.tabParam.powerStationType;
      const cityIds = window.LayoutTab.tabParam.cityIds
        ? window.LayoutTab.tabParam.cityIds.split(",")
        : [];
      const provinceIds = window.LayoutTab.tabParam.provinceIds
        ? window.LayoutTab.tabParam.provinceIds.split(",")
        : [];
      if (provinceIds.length > 0) {
        if (provinceIds[0] != "000000") {
          this.initCity.push(provinceIds[0]);
        }
      }
      if (cityIds.length > 0) {
        this.initCity.push(`${cityIds[0].substr(0, 2)}0000`);
        this.initCity.push(cityIds[0]);
      }
    }
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.isFirst = true;
    this.hasSearch = false;
    this.state = {
      data: [],
      reqId: null,
      stationTypeOptions: [
        {
          text: "全部",
          value: "",
        },
      ],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      tableParam: {
        stubGroupName: this.queryStubName,
        // operationProperty: "3",
        // stubGroupId:this.queryStubGroupId,
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
        isWallBox: true,
      },
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      currentParam: {},
    };
  }

  /**
   * 页面加载前调用方法，初始化查询form表单
   */
  componentWillMount() {
    /**
     * 设备状态定义
     */
    this.stateOption = StubStruts();
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  generateTableButtons() {
    return (
      <div className="table-btn-group">
        {useAuth("011004") && (
          <Button
            type="primary"
            style={{ marginRight: "5px" }}
            onClick={() => this.selectCurrent(1)}>
            {this.internationalization.btn6}
          </Button>
        )}
        {useAuth("011005") && (
          <Button
            type="primary"
            style={{ marginRight: "5px" }}
            onClick={() => this.selectCurrent(2)}>
            {this.internationalization.btn12}
          </Button>
        )}
      </div>
    );
  }

  selectCurrent = (type) => {
    const id = [];
    if (this.state.selectedRows) {
      this.state.selectedRows.forEach((key) => {
        id.push({
          stubId: key.key,
          oldStatus: key.status,
        });
      });
    }
    if (id.length > 0) {
      if (type == 1) {
        // 修改状态
        this.setState({
          seeStubStatusVisible: true,
          stubIds: JSON.stringify(id),
          isBatch: 1,
        });
      } else {
        // 修改质保
        this.setState({
          seeStubTenceVisible: true,
          stubIds: JSON.stringify(id),
          tenceTime: null,
          companyId: null,
          isBatch: 1,
        });
      }
    } else {
      message.error("请至少选择一个充电桩");
    }
  };

  // fetchStationList = (params) => {
  //   fetchHandler(getEquipmentList, {
  //     ...params,
  //   }).then((res) => {
  //     if (res && res.code === "success") {
  //       const dataSource = res.data;
  //       this.setState({
  //         dataSource,
  //         selectedRows: this.props.selectedStations,
  //         selectedRowKeys: this.props.selectedStations
  //           ? this.props.selectedStations.map((item) => item.key) : [],
  //       }, () => {
  //         this.setState({
  //           ...this.init(),
  //         });
  //       });
  //     }
  //   });
  // }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载完成调用方法，表格数据加载，并且初始化值
   */
  componentDidMount() {
    this.fetchApi(this.state.tableParam);
    this.setState({
      stubGroupName: "",
      meterModuleId: "",
      stubId: "",
      tableParam: {
        stubGroupName: "",
        stubGroupId: "",
        meterModuleId: "",
        stubId: "",
        // operationProperty: "3",
      },
    });
  }

  /**
   * 查询form表单初始化
   */
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // .'请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          defaultValue: this.queryStubId,
          labelName: this.internationalization.title1, // '设备编号:',
          required: false,
        },
        // {
        //   type: "input",
        //   placeholder: this.internationalization.placeholder2, // '请输入电站名称',
        //   param: {
        //     name: "stubGroupName",
        //     type: "string",
        //   },
        //   defaultValue: this.queryStubName,
        //   labelName: this.internationalization.title2, // '电站名称:',
        //   required: false,
        // },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.title8, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: this.internationalization.wz9, // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          defaultValue: this.initCity.length == 0 ? [] : this.initCity,
        },
        // {
        //   type: "input",
        //   placeholder: this.internationalization.wz1, // '请输入配电柜编号',
        //   param: {
        //     name: "meterModuleId",
        //     type: "string",
        //   },
        //   defaultValue: this.queryMeterModuleId,
        //   labelName: this.internationalization.wz2, // '配电柜编号',
        //   required: false,
        // },
        {
          type: "autoWatch",
          placeholder: this.internationalization.title10, // '请选择:',
          param: {
            name: "modelNo",
            type: "string",
          },
          labelName: this.internationalization.title11, // '设备型号',
          required: !1,
          sourceApi: getModelNoList,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              placeholder: this.internationalization.title15, // '固件型号:',
              width: "95px",
              param: {
                name: "updateType",
                type: "string",
              },

              labelName: this.internationalization.wz3, // '固件信息','固件信息:',
              dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
              required: false,
              onChange: async (value, form) => {
                form.setFieldsValue({
                  frameWork: "",
                  updateType: value,
                });
                fetchHandler(getFrameWorkList, {
                  updateType: value,
                }).then((res) => {
                  const finalData = res.data;
                  finalData.unshift("全部");
                  this.setState(
                    {
                      xhList: finalData.map((v) => {
                        return {
                          text: v,
                          value: v,
                        };
                      }),
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                });
              },
            },
            {
              type: "select",
              placeholder: this.internationalization.title13, // '固件版本:',
              width: "95px",
              param: {
                name: "frameWork",
                type: "string",
              },
              options: this.state.xhList,
              required: false,
            },
          ],
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "质保时效", // '设备状态',
          param: {
            name: "tenceType",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "未过保",
              value: "2",
            },
            {
              text: "已过保",
              value: "1",
            },
            {
              text: "即将过保（30天内过保）",
              value: "3",
            },
          ],
          required: false,
          defaultValue: this.operationMode ? this.operationMode : "",
        },
        // {
        //   type: "select",
        //   placeholder: "请选择", // '请选择设备状态',
        //   labelName: "运营类型", // '设备状态',
        //   param: {
        //     name: "operationMode",
        //     type: "string",
        //   },
        //   options: [
        //     {
        //       text: "全部",
        //       value: "",
        //     },
        //     {
        //       text: "非直营",
        //       value: "0",
        //     },
        //     {
        //       text: "直营",
        //       value: "1",
        //     },
        //   ],
        //   required: false,
        //   onChange: (e, form) => {
        //     form.setFieldsValue({
        //       powerStationType: "",
        //       operationMode: e,
        //     });
        //     let stationTypeOptions = [];
        //     if (e && e != null && e != "") {
        //       stationTypeOptions = opType[e];
        //     }
        //     this.setState(
        //       {
        //         stationTypeOptions: stationTypeOptions,
        //       },
        //       () => {
        //         this.setState({
        //           formConfig: this.initFormConfig(),
        //         });
        //       },
        //     );
        //   },
        //   defaultValue: this.operationMode ? this.operationMode : "",
        // },
        // {
        //   type: "select",
        //   placeholder: "请选择", // '请选择电站类型',
        //   labelName: "电站类型", // '电站类型',
        //   param: {
        //     name: "powerStationType",
        //     type: "string",
        //   },
        //   options: this.state.stationTypeOptions,
        //   required: false,
        //   defaultValue: this.powerStationType ? this.powerStationType : "",
        // },
        // {
        //   type: "select",
        //   options: [
        //     {
        //       text: this.yunwei.wz10, // '全部',
        //       value: "",
        //     },
        //     {
        //       text: this.internationalization.title20, // '交流电',
        //       value: "0",
        //     },
        //     {
        //       text: this.internationalization.title21, // '直流电',
        //       value: "1",
        //     },
        //     {
        //       text: this.internationalization.title22, // '交直流',
        //       value: "2",
        //     },
        //   ],
        //   placeholder: this.internationalization.title8, // '请选择设备类型',
        //   param: {
        //     name: "stubType",
        //     type: "string",
        //   },
        //   labelName: this.internationalization.title19, // '设备类型',
        //   required: false,
        //   defaultValue: this.stubType ? this.stubType : "",
        // },
        {
          type: "select",
          placeholder: this.internationalization.title8, // '请选择设备状态',
          labelName: this.internationalization.title27, // '设备状态',
          param: {
            name: "stubStatus",
            type: "string",
          },
          options: this.stateOption,
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入iccid卡号", // .'请输入设备编号',
          param: {
            name: "iccid",
            type: "string",
          },
          labelName: "iccid卡号", // '设备编号:',
          required: false,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("011001")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.title16, // '查询'
                }
              : "",
            useAuth("011002")
              ? {
                  btnType: "button",
                  text: this.internationalization.btn8, // 导出
                  handler: (e, param) => {
                    this.exportData(param);
                  },
                }
              : "",
            useAuth("011003")
              ? {
                  btnType: "button",
                  text: this.internationalization.btn13, // 批量导入质保
                  handler: (e, param) => {
                    this.setState({
                      seeStubImportVisible: true,
                    });

                    // this.exportData(param);
                  },
                }
              : "",
            // useAuth("011005")
            //   ? {
            //       btnType: "button",
            //       text: "HPC设备批量升级", // HPC设备批量升级
            //       handler: (e, param) => {
            //         // var id = [];
            //         const add = [];
            //         if (this.state.selectedRows) {
            //           let hs = false;
            //           this.state.selectedRows.forEach((key) => {
            //             if (key.key.length != 11 || key.key.substr(0, 1) != "8") {
            //               hs = true;
            //             } else {
            //               let num = "";
            //               if (key.key.substr(9, 11) != "01") {
            //                 num = `${key.key.substr(0, 9)}01`;
            //               } else {
            //                 num = key.key;
            //               }

            //               if (add.indexOf(num) == -1) {
            //                 add.push(num);
            //                 // id.push({
            //                 //   stubId: num,
            //                 //   oldStatus: key.status
            //                 // })
            //               }
            //             }
            //           });
            //           if (hs) {
            //             message.error("只有HPC设备支持批量升级");
            //             return;
            //           }
            //         }
            //         console.info("选中的信息：");
            //         console.info(JSON.stringify(add));
            //         if (add.length > 0) {
            //           this.setState({
            //             frameWorkUpdateBatchVisible: true,
            //             stubIds: add.join(","),
            //             stubIdsArray: add,
            //             isBatch: 1,
            //           });
            //         } else {
            //           message.error("请至少选择一个充电桩");
            //         }
            //         // this.exportData(param);
            //       },
            //     }
            //   : "",
            useAuth("011006")
              ? {
                  btnType: "button",
                  text: "HPC日志下载记录", // HPC日志下载记录
                  handler: (e, param) => {
                    this.openTab(
                      {
                        keyId: "098923",
                      },
                      {
                        key: "098923",
                        titleText: "HPC日志下载记录",
                      },
                    );
                  },
                }
              : "",
            useAuth("011007")
              ? {
                  btnType: "button",
                  text: "批量导入温度阈值",
                  handler: (e, param) => {
                    this.setState({
                      seeTempThresholdVisible: true,
                    });
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        // stubGroupName: this.queryStubName,
        // powerBoxId: localStorage.meterModuleId,
        meterId: this.queryMeterModuleId,
        stubId: this.queryStubId,
        // operationProperty: "3",
      },

      context: this,
      tableKey: "wallSearchTable",
      tablePage: "设备快速查询",
    };
    return formConfig;
  };

  // 数据导出
  exportData = (param) => {
    console.log(param);
    const excelUrl = `${prefixFile}/exportStubInfo.do`;

    param.locale = this.props.intl.locale;

    if (param.updateType === this.yunwei.wz10) {
      param.updateType = "";
    }
    param.token = window.sessionStorage.getItem("token");
    param.companyId = window.sessionStorage.getItem("companyId");
    if (param.frameWork === this.yunwei.wz10) {
      param.frameWork = "";
    }
    // 城市id格式化
    param.cityId =
      param.cityId === undefined
        ? ""
        : param.cityId
            .toString()
            .slice(param.cityId.toString().lastIndexOf(",") + 1, param.cityId.toString().length);

    if (param.stubGroupName === this.queryStubName && !this.hasSearch) {
      param.stubGroupId = this.queryStubGroupId;
    } else {
      param.stubGroupId = "";
    }

    param["isWallBox"] = true;

    let params = "";
    Object.keys(param).forEach((key) => {
      if (param[key] !== undefined) {
        params += `${key}=${param[key]}&`;
      }
    });
    const ele = document.createElement("a");
    console.log("paramString", params);
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  /**
   *
   * 表格初始化
   */
  init = () => {
    this.queryStubId = "";
    this.queryStubName = "";
    this.queryStubGroupId = "";
    this.queryMeterModuleId = "";

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.operationMode = window.LayoutTab.tabParam.operationMode
        ? window.LayoutTab.tabParam.operationMode
        : "";
      this.powerStationType = window.LayoutTab.tabParam.powerStationType
        ? window.LayoutTab.tabParam.powerStationType
        : "";
      this.stubType = window.LayoutTab.tabParam.stubType ? window.LayoutTab.tabParam.stubType : "";
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
      if (window.LayoutTab.tabParam.initSetting && window.LayoutTab.tabParam.initSetting.stubId) {
        this.queryStubId = window.LayoutTab.tabParam.initSetting.stubId;
      }
      this.queryStubName = window.LayoutTab.tabParam.StubName
        ? window.LayoutTab.tabParam.StubName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
      this.queryMeterModuleId = window.LayoutTab.tabParam.meterModuleId
        ? window.LayoutTab.tabParam.meterModuleId
        : "";
    }

    this.tableConfig = {
      tableKey: "wallSearchTable",
      tableColumns: [
        {
          name: this.internationalization.title1, // '设备编号',
          key: "key",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备名称", // '设备名称',
          key: "name",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "项目编号",
          key: "projectNumber",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "电站ID",
          key: "stationId",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.title18, // '所属电站',
          key: "stubGroupName",
          colType: "tipCol",
          align: "left",
          width: 200,
        },
        {
          name: "地区",
          key: "cityName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.title19, // '设备类型'
          key: "type",
          align: "left",
          width: 200,
          colType: "textCol",
          render: (value) => {
            switch (value) {
              case 0:
                return this.internationalization.title20; // '交流电';
              case 1:
                return this.internationalization.title21; // '直流电';
              case 2:
                return this.internationalization.title22; // '交直流';
              default:
                return this.internationalization.title23; // '未知'
            }
          },
        },
        {
          name: this.yunwei.wz0, // '运营类型',
          key: "operationMode",
          colType: "textCol",
          align: "left",
          width: 200,
          render: (value) => {
            if (value.toString() === "1") {
              return "直营";
            } else if (value.toString() === "0") {
              return "非直营";
            } else {
              return "--";
            }
          },
        },
        {
          name: "电站类型", // '运营类型',
          key: "powerStationType",
          colType: "textCol",
          align: "left",
          width: 200,
          render: (value) => {
            if (value == null) {
              return "--";
            } else if (value.toString() === "0") {
              return "平台托管联营站";
            } else if (value.toString() === "1") {
              return "品牌联营站";
            } else if (value.toString() === "2") {
              return "互联互通联营站";
            } else if (value.toString() === "3") {
              return "专用开放站";
            } else if (value.toString() === "4") {
              return "专用内部站";
            } else if (value.toString() === "5") {
              return "品牌站";
            } else if (value.toString() === "6") {
              return "自建站";
            } else if (value.toString() === "8") {
              return "共建站";
            } else {
              return "--";
            }
            // else if (value.toString() === "7") {
            //   return "互联互通站";
            // }
          },
        },
        {
          name: this.internationalization.title24, // '设备型号',
          key: "modelNo",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.wz3, // '固件信息',
          key: "updateType",
          colType: "textCol",
          align: "left",
          width: 200,
          render: (value, row) => {
            if (value === "--") {
              return "--";
            } else {
              if (row.smallVersion !== "--" && row.smallVersion !== "" && row.smallVersion) {
                return `${value}-${row.frameWork}-${row.smallVersion}`; // 增加小版本号
              } else {
                return `${value}-${row.frameWork}`; // 增加小版本号
              }
            }
          },
        },
        {
          name: this.internationalization.title27, // '设备状态',
          key: "statusName",
          colType: "textCol",
          align: "left",
          width: 200,
          render: (text, res) => {
            return (
              <div>
                {text}{" "}
                {text == "升级中" ? (
                  <a
                    onClick={() => {
                      if (res.key.length == 11 && res.key.substr(0, 1) == "8") {
                        const add = [res.key];
                        this.stubInfoData = {
                          reqId: res.key,
                          from: "hpc",
                          stubIds: add,
                          stubIdsStr: add.join(","),
                        };
                      } else {
                        this.stubInfoData = res;
                      }
                      this.setState({
                        reqId: res.key,
                        progressVisible: true,
                      });
                    }}>
                    进度
                  </a>
                ) : null}
              </div>
            );
          },
        },
        {
          name: "iccid卡号", // 'iccid卡号',
          key: "iccid",
          colType: "textCol",
          align: "left",
        },
        {
          name: "托管到期时间", // 'iccid卡号',
          key: "enableEndDate",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            let color = null;
            if (!value || value == null || value == "" || value == "--") {
              color = "rgb(82 196 26)";
            } else {
              const enableEndDate = moment(value);
              const curData = new Date();
              curData.setHours(0);
              curData.setMinutes(0);
              curData.setSeconds(0);
              curData.setMilliseconds(0);
              if (enableEndDate >= curData) {
                color = "rgb(28 127 250)";
              } else {
                color = "rgb(250, 84, 28)";
              }
            }
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "0 22px",
                }}>
                <div className="tip-lv">
                  <span className="first" style={{ background: color }}></span>
                  <span className="last" style={{ background: color }}></span>
                </div>
                <span>{row.enableEndDate}</span>
              </div>
            );
          },
        },
        // {
        //   name: "地锁编号", // '地锁编号',
        //   key: "lockId",
        //   colType: "textCol",
        //   align: "left",
        // },

        // {
        //   name: "地锁品牌", // '地锁品牌',
        //   key: "lockBrand",
        //   colType: "textCol",
        //   align: "left",
        //   width: 200,
        //   render: (value) => {
        //     if (value == null) {
        //       return "--";
        //     } else if (value.toString() === "0") {
        //       return "开迈斯地锁";
        //     } else if (value.toString() === "1") {
        //       return "蓝牙";
        //     } else if (value.toString() === "2") {
        //       return "慧铂金";
        //     } else if (value.toString() === "3") {
        //       return "万科地锁";
        //     } else if (value.toString() === "4") {
        //       return "丁丁地锁";
        //     } else if (value.toString() === "5") {
        //       return "豪位地锁";
        //     } else if (value.toString() === "9") {
        //       return "克莱玛地锁";
        //     } else {
        //       return "--";
        //     }
        //   },
        // },

        // {
        //   name: "地锁状态", // '地锁状态',
        //   key: "lockStatus",
        //   colType: "textCol",
        //   align: "left",
        //   width: 200,
        //   render: (value) => {
        //     if (value == null) {
        //       return "--";
        //     } else if (value.toString() == "0") {
        //       return "降下";
        //     } else if (value.toString() == "1") {
        //       return "升起";
        //     } else if (value.toString() == "2") {
        //       return "故障";
        //     } else if (value.toString() == "3") {
        //       return "锁车";
        //     } else if (value.toString() == "4") {
        //       return "休眠";
        //     } else if (value.toString() == "5") {
        //       return "未知";
        //     } else if (value.toString() == "6") {
        //       return "离网";
        //     } else if (value.toString() == "9") {
        //       return "占用";
        //     } else {
        //       return "--";
        //     }
        //   },
        // },

        // {
        //   name: "车位状态", // '车位状态',
        //   key: "parkStatus",
        //   colType: "textCol",
        //   align: "left",
        //   width: 200,
        //   render: (value) => {
        //     if (value == null) {
        //       return "--";
        //     } else if (value.toString() === "0") {
        //       return "无车";
        //     } else if (value.toString() === "1") {
        //       return "有车";
        //     } else if (value.toString() === "2") {
        //       return "未知";
        //     } else if (value.toString() === "3") {
        //       return "故障";
        //     } else {
        //       return "--";
        //     }
        //   },
        // },

        // {
        //   name: "电量", // '电量',
        //   key: "soc",
        //   colType: "textCol",
        //   align: "left",
        // },
        {
          name: "实时功率", // '实时功率',
          key: "chargeKw",
          colType: "textCol",
          align: "left",
        },
        // {
        //   name: "地锁二维码",
        //   key: "qrCode",
        //   // colType: "thumbImage", // 地锁二维码
        //   colType: "textCol",
        //   align: "left",
        //   width: 200,
        //   render: (value) => {
        //     if (value != "--") {
        //       return (
        //         <a
        //           onClick={() => {
        //             this.stubInfoData = value;
        //             this.modalVisibleAction("statusVisible", true);
        //           }}>
        //           查看
        //         </a>
        //         // <QRCode value={value} size={100} />
        //       );
        //     } else {
        //       return "暂无";
        //     }
        //   },
        // },

        {
          name: "质保供应商", // '供应商',
          key: "companyName",
          colType: "textCol",
          align: "left",
        },
        {
          name: "质保截止时间", // '质保截止时间',
          key: "tenceTimeDate",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            // {
            //     type: 'href',
            //     actionName: '实时状态',
            //     render: (text, res) => {
            //         //return res.status === '已完成' ?
            //  null : (res.status === '已处理' ? null : '填写跟进人');
            //     },
            //     handler: (res) => {
            //     }
            // },
            useAuth("011008")
              ? {
                  type: "href",
                  actionName: this.internationalization.wz5, // '配置信息',
                  handler: (record) => {
                    if (record.key.length != 11 || record.key.substr(0, 1) != "8") {
                      this.setState({
                        seeParamsConfigVisible: true,
                        stubId: record.key,
                        stubGroupName: record.stubGroupName,
                        devType: record.type,
                      });
                    } else {
                      this.setState({
                        hpcSettingVisible: true,
                        stubId: record.key,
                      });
                    }
                  },
                }
              : "",
            // {
            //     type: 'href',
            //     actionName: '设备详情',
            //     handler: (res) => {
            //         this.stubInfoData = res;
            //         this.modalVisibleAction('seeDetailVisible',true);
            //         this.setState({
            //             seeDetailVisible : true
            //         })
            //     }
            // },
            useAuth("011009")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn4, // '基础信息',
                  handler: (res) => {
                    this.openTab(
                      {
                        stubId: res.key,
                      },
                      {
                        key: "stubBasicInfo",
                        titleText: this.internationalization.btn4,
                      },
                    );
                    this.stubInfoData = res;
                    // this.modalVisibleAction('seeDetailVisible', true);
                    // this.setState({
                    //     seeDetailVisible: true
                    // })
                  },
                }
              : "",
            useAuth("011010")
              ? {
                  type: "href",
                  actionName: this.internationalization.wz6, // '模块信息',
                  handler: (record) => {
                    this.openTab(
                      {
                        keyId: `moduleInfo${record.key}`,
                        stubId: record.key,
                      },
                      {
                        key: "moduleInfo",
                        titleText: this.internationalization.wz6, // '模块信息',
                      },
                    );
                  },
                }
              : "",
            useAuth("011011")
              ? {
                  type: "href",
                  actionName: this.internationalization.wz10, // '维修记录',
                  handler: (record) => {
                    this.openTab(
                      {
                        stubId: record.key,
                      },
                      {
                        key: "0106",
                        titleText: this.internationalization.wz10, // '维修记录',
                      },
                    );
                  },
                }
              : "",
            useAuth("011012")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn5, // '订单信息',
                  handler: (record) => {
                    this.openTab(
                      {
                        // keyId: "0501",
                        wallBoxInfoData: record,
                      },
                      {
                        key: "0510",
                        titleText: this.internationalization.btn5, // '订单信息',
                      },
                    );
                  },
                }
              : "",
            useAuth("011013")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn2, // '修改状态',
                  handler: (record) => {
                    this.setState({
                      seeStubStatusVisible: true,
                      stubId: record.key,
                      isBatch: null,
                      oldStatus: record.status,
                    });
                  },
                }
              : "",
            useAuth("011014")
              ? {
                  type: "href",
                  actionName: this.internationalization.btn11, // '修改质保',
                  render: (record) => {
                    return <span>修改质保</span>;
                  },
                  handler: (record) => {
                    this.setState({
                      seeStubTenceVisible: true,
                      stubId: record.key,
                      companyId: record.companyId,
                      tenceTime: record.tenceTime,
                      isBatch: null,
                    });
                  },
                }
              : "",
            useAuth("011015")
              ? {
                  type: "href",
                  actionName: "固件升级",
                  render: (record) => {
                    return record.statusName === "升级中" ? null : "固件升级";
                  },
                  handler: (record) => {
                    if (record.key.length == 11 && record.key.substr(0, 1) == "8") {
                      this.stubInfoData = {
                        stubIds: [record.key],
                        stubIdsStr: record.key,
                      };
                    } else {
                      this.stubInfoData = record;
                    }
                    this.setState({
                      updateStatus: null,
                      frameWorkUpdateVisible: true,
                      stubId: record.key,
                      frameType: record.updateType,
                      frameWork: record.frameWork,
                      smallVersion: record.smallVersion, // 增加小版本号
                      isBatch: null,
                    });
                  },
                }
              : "",
            // useAuth("011016")
            //   ? {
            //       type: "href",
            //       actionName: "桩端日志",
            //       render: (record) => {
            //         if (record.key.length != 11 || record.key.substr(0, 1) != "8") {
            //           return null;
            //         } else {
            //           return <span>桩端日志</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         this.setState({
            //           downLogStatus: null,
            //           stubLogVisible: true,
            //           stubId: record.key,
            //           isBatch: null,
            //         });
            //       },
            //     }
            //   : "",
            useAuth("011017")
              ? {
                  type: "href",
                  actionName: "状态日志",
                  handler: (record) => {
                    this.stubInfoData = record;
                    this.modalVisibleAction("statusLogVisible", true);
                  },
                }
              : "",
            useAuth("011018")
              ? {
                  type: "confirm",
                  actionName: "远程解锁",
                  popText: () => {
                    return `确定要远程解锁吗？`;
                  },
                  render: (record) => {
                    if (record.key.length != 11 || record.key.substr(0, 1) != "8") {
                      return null;
                    } else {
                      return <span>远程解锁</span>;
                    }
                  },
                  handler: (record) => {
                    fetchHandler(unlockConnector, {
                      stubId: record.key,
                    }).then((res) => {
                      if (res && (res.code === "ok" || res.code === "success")) {
                        message.success("远程解锁成功");
                        RefreshGrid(this.context.store, "wallSearchTable");
                      }
                    });
                  },
                }
              : "",
            useAuth("011019")
              ? {
                  type: "href",
                  actionName: "远程复位", // '修改状态',
                  render: (record) => {
                    return <span>远程复位</span>;
                  },
                  handler: (record) => {
                    this.setState({
                      stubRestartLockVisible: true,
                      stubId: record.key,
                      isBatch: null,
                    });
                  },
                }
              : "",
            // useAuth("011020")
            //   ? {
            //       type: "href",
            //       actionName: "绑定地锁", // '绑定地锁',
            //       render: (record) => {
            //         if (record.lockId != "--") {
            //           return null;
            //         } else {
            //           return <span>绑定地锁</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         this.setState({
            //           seeStubBindLockVisible: true,
            //           stubId: record.key,
            //           isBatch: null,
            //         });
            //       },
            //     }
            //   : "",
            // useAuth("011021")
            //   ? {
            //       type: "confirm",
            //       actionName: "解绑地锁",
            //       popText: () => {
            //         return `确定要解绑地锁吗？`;
            //       },
            //       render: (record) => {
            //         if (record.lockId == "--") {
            //           return null;
            //         } else {
            //           return <span>解绑地锁</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         fetchHandler(lockUnBind, {
            //           stubId: record.key,
            //         }).then((res) => {
            //           if (res && (res.code === "ok" || res.code === "success")) {
            //             message.success("解绑地锁成功");
            //             RefreshGrid(this.context.store, "wallSearchTable");
            //           }
            //         });
            //       },
            //     }
            //   : "",
            // useAuth("011022")
            //   ? {
            //       type: "confirm",
            //       actionName: "休眠地锁",
            //       popText: () => {
            //         return `确定要休眠地锁吗？`;
            //       },
            //       render: (record) => {
            //         if (record.lockId == "--") {
            //           return null;
            //         } else {
            //           return <span>休眠地锁</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         fetchHandler(lockSleepOrWake, {
            //           stubId: record.key,
            //           status: 1,
            //         }).then((res) => {
            //           if (res && (res.code === "ok" || res.code === "success")) {
            //             message.success("休眠地锁成功");
            //           }
            //         });
            //       },
            //     }
            //   : "",
            // useAuth("011023")
            //   ? {
            //       type: "confirm",
            //       actionName: "唤醒地锁",
            //       popText: () => {
            //         return `确定要唤醒地锁吗？`;
            //       },
            //       render: (record) => {
            //         if (record.lockId == "--") {
            //           return null;
            //         } else {
            //           return <span>唤醒地锁</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         fetchHandler(lockSleepOrWake, {
            //           stubId: record.key,
            //           status: 2,
            //         }).then((res) => {
            //           if (res && (res.code === "ok" || res.code === "success")) {
            //             message.success("唤醒地锁成功");
            //           }
            //         });
            //       },
            //     }
            //   : "",
            // useAuth("011024")
            //   ? {
            //       type: "href",
            //       actionName: "是否支持预约", // '修改状态',
            //       render: (record) => {
            //         if (record.lockId == "--") {
            //           return null;
            //         } else {
            //           return <span>是否支持预约</span>;
            //         }
            //       },
            //       handler: (record) => {
            //         this.setState({
            //           seeStubOrderLockVisible: true,
            //           stubId: record.key,
            //           isBatch: null,
            //         });
            //       },
            //     }
            //   : "",
            useAuth("011025")
              ? {
                  type: "href",
                  actionName: "挪桩记录",
                  handler: (record) => {
                    this.openTab(
                      {
                        stubId: record.key,
                      },
                      {
                        key: "0109",
                        titleText: "挪桩设备查询",
                      },
                    );
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
        isWallBox: true,
      },

      tableInfo: {
        hasRow: !0, // 是否显示checkbox
        footer: this.generateTableButtons(),
        rowSelection: {
          selectedRowKeys: this.state ? this.state.selectedRowKeys : [],
          onChange: (selectedRowKeys, selectedRows) => {
            this.setState(
              {
                selectedRowKeys,
                selectedRows,
              },
              () => {
                this.setState({
                  ...this.init(),
                });
              },
            );
          },
        },
      },
      dataApi: getStubInfoList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
  };

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;

    if (newParam.updateType === this.yunwei.wz10) {
      newParam.updateType = "";
    }

    if (newParam.frameWork === this.yunwei.wz10) {
      newParam.frameWork = "";
    }

    if (newParam.smallVersion === this.yunwei.wz10) {
      // 增加小版本号
      newParam.smallVersion = "";
    }
    if (param.operationMode == "" || param.operationMode == 0 || param.operationMode == 1) {
      newParam.operationMode = param.operationMode;
    } else {
      newParam.operationMode = this.operationMode;
    }

    if (param.stubType == "" || param.stubType == 0 || param.stubType == 1 || param.stubType == 2) {
      newParam.stubType = param.stubType;
    } else {
      newParam.stubType = this.stubType;
    }
    // 城市id格式化
    const selectCity =
      this.initCity.length == 0 ? (param.cityId && param.cityId.split(",")) || [] : this.initCity;
    switch (selectCity.length) {
      case 1:
        newParam.cityId = selectCity[0];
        break;
      case 2:
        newParam.cityId = selectCity[1];
        break;
      case 3:
        newParam.cityId = selectCity[2];
        break;
      default:
        newParam.cityId = "";
        break;
    }
    this.initCity = [];
    if (this.isFirst) {
      this.isFirst = false;
      newParam.stubGroupId = this.queryStubGroupId;
    } else {
      this.hasSearch = true;
      newParam.stubGroupId = "";
      param.stubGroupId = "";
    }
    this.setState({
      tableParam: param,
    });
    // newParam.operationProperty = "3";
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      this.setState({
        currentParam: newParam,
      });
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "wallSearchTable", newParam);
    }
  };

  // 更新frameType
  updateFramType = () => {
    fetchHandler(getStubInfoList, {
      stubId: this.stubInfoData.key,
    }).then((res) => {
      if (res && (res.code === "success" || res.code === "ok")) {
        this.setState({
          frameType: res.data[0].updateType,
          frameWork: res.data[0].frameWork,
        });
      }
    });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>

        {/* <Modal  title="电桩详情"
        visible={this.state.seeDetailVisible}
        footer={null} destroyOnClose={true} */}
        {/*        width={'1000px'} */}
        {/*        onCancel = {()=>{this.modalVisibleAction('seeDetailVisible',false)} }> */}
        {/*    <StubDetailInfo stubInfoData={this.stubInfoData}/> */}
        {/* </Modal> */}

        {/* <Modal  title="电桩详情"
        visible={this.state.seeDetailVisible} footer={null} destroyOnClose={true} */}
        {/*        width={'1000px'} */}
        {/*        onCancel = {()=>{this.modalVisibleAction('seeDetailVisible',false)} }> */}
        {/*    <StubOrderInfo params={this.stubInfoData}/> */}
        {/* </Modal> */}

        <Modal
          title={this.internationalization.btn4}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          {/* <Tabs type="card">
                    <TabPane tab="基础信息" key="stubDetailInfo">
                        <StubDetailInfo stubInfoData={this.stubInfoData}/>
                    </TabPane>
                    <TabPane tab="模块信息" key="moduleInfo">
                        <ModuleInfo />
                    </TabPane>
                    <TabPane tab="订单信息" key="stubOrderInfo">
                        <StubOrderInfo  params={this.stubInfoData} onAdd={this.props.onAdd}
                                        cancelModal={() => {this.cancelModal('seeDetailVisible')}}/>
                    </TabPane>
                </Tabs> */}

          <StubDetailInfo
            stubInfoData={this.stubInfoData}
            refreshGrid={() => {
              this.fetchApi(this.state.tableParam);
            }}
          />
        </Modal>

        <Modal
          title={this.internationalization.btn6}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubStatusVisible", false);
          }}>
          <StubStatusUpdate
            oldStatus={this.state.oldStatus}
            stubIds={this.state.stubIds}
            stubId={this.state.stubId}
            isBatch={this.state.isBatch}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="是否支持续约"
          visible={this.state.seeStubOrderLockVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubOrderLockVisible", false);
          }}>
          <StubLockOrderStatus
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubOrderLockVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="HPC配置信息"
          visible={this.state.hpcSettingVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("hpcSettingVisible", false);
          }}>
          <HpcSettingModalS
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ hpcSettingVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="远程复位"
          visible={this.state.stubRestartLockVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("stubRestartLockVisible", false);
          }}>
          <StubRestartModalS
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ stubRestartLockVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="修改质保信息"
          visible={this.state.seeStubTenceVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubTenceVisible", false);
          }}>
          <SeeStubTenceInfo
            stubIds={this.state.stubIds}
            stubId={this.state.stubId}
            isBatch={this.state.isBatch}
            tenceTime={this.state.tenceTime}
            companyId={this.state.companyId}
            onCancel={() => {
              this.setState({ seeStubTenceVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="批量导入质保"
          visible={this.state.seeStubImportVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubImportVisible", false);
          }}>
          <GoodExcelIn
            onCancel={() => {
              this.setState({ seeStubImportVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="批量导入温度阈值"
          visible={this.state.seeTempThresholdVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeTempThresholdVisible", false);
          }}>
          <GoodExcelInTemp
            onCancel={() => {
              this.setState({ seeTempThresholdVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title="绑定地锁"
          visible={this.state.seeStubBindLockVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubBindLockVisible", false);
          }}>
          <StubBindLock
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubBindLockVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "wallSearchTable");
            }}
          />
        </Modal>

        <Modal
          title={this.internationalization.btn7}
          visible={this.state.seeParamsConfigVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeParamsConfigVisible", false);
          }}>
          <StubParamsConfig
            isWallBox={true}
            stubId={this.state.stubId}
            stubGroupName={this.state.stubGroupName}
            devType={this.state.devType}
          />
        </Modal>

        <Modal
          title={this.internationalization.wz7}
          visible={this.state.getFrameWorkVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("getFrameWorkVisible", false);
          }}>
          <GetFrameWorkEdition
            endModal={() => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("getFrameWorkVisible", false);
            }}
            stubId={this.state.stubId}
            onCancel={() => {
              this.modalVisibleAction("getFrameWorkVisible", false);
            }}
          />
        </Modal>
        <Modal
          title={this.internationalization.wz8}
          visible={this.state.frameWorkUpdateBatchVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("frameWorkUpdateBatchVisible", false);
            // RefreshGrid(this.context.store, 'wallSearchTable', this.state.currentParam);
          }}>
          <FrameWorkUpdateBatch
            updateFramType={() => {
              this.updateFramType();
            }}
            frameWorkUpdateBatchFunc={(reqId) => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("frameWorkUpdateBatchVisible", false);
              this.stubInfoData = {
                reqId: reqId,
                stubIds: this.state.stubIdsArray,
                stubIdsStr: this.state.stubIds,
              };
              this.setState({
                reqId: reqId,
                progressVisible: true,
              });
            }}
            errorHandler={() => {
              this.modalVisibleAction("frameWorkUpdateBatchVisible", false);
              this.setState({
                updateStatus: "error",
                progressVisible: true,
              });
            }}
            stubIds={this.state.stubIds}
            onCancel={() => {
              this.modalVisibleAction("frameWorkUpdateBatchVisible", false);
            }}
          />
        </Modal>

        <Modal
          title="HPC桩端日志"
          visible={this.state.stubLogVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("stubLogVisible", false);
            // RefreshGrid(this.context.store, 'wallSearchTable', this.state.currentParam);
          }}>
          <DownHPCStubLog
            downHPCStubLogFunc={(logId) => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("stubLogVisible", false);
              this.setState({
                logId: logId,
                downLogStatus: "",
                downLogprogressTVisible: true,
              });
            }}
            errorHandler={() => {
              // this.modalVisibleAction("stubLogVisible", false);
              this.setState({
                downLogStatus: "error",
                downLogprogressTVisible: false,
              });
            }}
            stubId={this.state.stubId}
            stubGroupName={this.state.stubGroupName}
            onCancel={() => {
              this.modalVisibleAction("stubLogVisible", false);
            }}
            devType={this.state.devType}
          />
        </Modal>

        <Modal
          title={this.internationalization.wz8}
          visible={this.state.frameWorkUpdateVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("frameWorkUpdateVisible", false);
            // RefreshGrid(this.context.store, 'wallSearchTable', this.state.currentParam);
          }}>
          <FrameWorkUpdate
            updateFramType={() => {
              this.updateFramType();
            }}
            frameWorkUpdateFunc={(reqId) => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                progressVisible: true,
                stubIds:
                  this.state.stubId.length != 11 || this.state.stubId.substr(0, 1) != "8"
                    ? null
                    : this.state.stubId,
                reqId: reqId,
              });
            }}
            errorHandler={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                updateStatus: "error",
                progressVisible: true,
              });
            }}
            stubId={this.state.stubId}
            frameWork={this.state.frameWork}
            frameType={this.state.frameType}
            smallVersion={this.state.smallVersion} // 增加小版本号
            stubGroupName={this.state.stubGroupName}
            onCancel={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
            }}
            devType={this.state.devType}
          />
        </Modal>
        <Modal
          title="查看地锁二维码"
          visible={this.state.statusVisible}
          footer={null}
          destroyOnClose
          width="360px"
          onCancel={() => {
            this.modalVisibleAction("statusVisible", false);
          }}>
          <div>
            <QRCode value={this.stubInfoData} size={300} />
          </div>
        </Modal>
        <Modal
          title="状态日志"
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <StubStatusLog stubIdData={this.stubInfoData && this.stubInfoData.key} />
        </Modal>

        <Modal
          visible={this.state.progressVisible}
          destroyOnClose
          footer={null}
          onCancel={() => {
            this.setState({ progressVisible: false });
          }}
          title="升级进度">
          <UpdateProgress
            reqId={this.state.reqId}
            record={this.stubInfoData}
            updateStatus={this.state.updateStatus}
          />
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <Button type="primary" onClick={() => this.setState({ progressVisible: false })}>
              隐藏
            </Button>
          </div>
        </Modal>

        <Modal
          visible={this.state.downLogprogressTVisible}
          destroyOnClose
          footer={null}
          onCancel={() => {
            this.setState({ downLogprogressTVisible: false });
          }}
          title="下载进度">
          <DownHPCLogProgress
            record={this.stubInfoData}
            updateStatus={this.state.downLogStatus}
            logId={this.state.logId}
          />
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <Button
              type="primary"
              onClick={() => this.setState({ downLogprogressTVisible: false })}>
              隐藏
            </Button>
          </div>
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(WallBoxStubList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/wallBoxStubList.js